import React, { useState, useEffect } from 'react';
import { format, sumHours } from '../tables/shared/FormatDetails';
import { FilterList } from '../../components/tables/shared/FormatDetails';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_HOURS, EMPLOYEE_DETAILS_DATE, EMPLOYEE_DETAILS_PROJECT_LABEL, EMPLOYEE_DETAILS_DESCRIPTION_LABEL, EMPLOYEE_DETAILS_NO_INTERNAL_HOURS_LABEL } from '../../i18n/keyConstants';

const EmpHourList = ({ hourInfo, startDate, endDate }) => {
    const { t } = useTranslation(['employeeDetails']);

    const [filteredHourInfo, setFilteredHourInfo] = useState(null);
    const [descriptionFilter, setDescriptionFilter] = useState('');
    const [projectFilter, setProjectFilter] = useState('');

    useEffect(() => {
        if (hourInfo) {
            let filtered = FilterList(hourInfo, startDate, endDate);

            if (projectFilter !== '' || descriptionFilter !== '') {
                filtered = filtered.filter(
                    (x) =>
                        x.projectName &&
                        x.projectName.toLowerCase().includes(projectFilter) &&
                        x.actionName &&
                        x.actionName.toLowerCase().includes(descriptionFilter)
                );
            }
            setFilteredHourInfo(filtered);
        }
    }, [descriptionFilter, projectFilter, hourInfo, startDate, endDate]);

    return (
        <>
            <div>
                {hourInfo && hourInfo.length ? (
                    <div className='padding-top-30px'>
                        <div className='d-flex justify-content-between col-12 employee-invoice padding-none'>
                            <table className='table table-striped table-sm font'>
                                <thead>
                                    <tr>
                                        <th className='padding-left-10px month'>{t(EMPLOYEE_DETAILS_DATE) }</th>
                                        <th className='text-right intern-hours padding-right-10px'>{t(EMPLOYEE_DETAILS_HOURS)}</th>
                                        <th>
                                            <input
                                                className='th-filter padding-left-10px w-100 border-0'
                                                type='text'
                                                placeholder={t(EMPLOYEE_DETAILS_PROJECT_LABEL) }
                                                onKeyUp={(e) => setProjectFilter(e.target.value.toLowerCase())}
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className='th-filter padding-left-10px w-100 border-0 text-truncate'
                                                type='text'
                                                placeholder={t(EMPLOYEE_DETAILS_DESCRIPTION_LABEL) }
                                                onKeyUp={(e) => setDescriptionFilter(e.target.value.toLowerCase())}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredHourInfo &&
                                        filteredHourInfo.map((inv, index) => (
                                            <tr key={index}>
                                                <td className='padding-left-10px month overflow-show'>{inv.date ? inv.date : ''}</td>
                                                <td className='text-right intern-hours'>{inv.hour ? format(inv.hour, 1) : ''}</td>
                                                <td className='prjnam padding-left-20px' data-tip data-for={'invoice-project-' + index}>
                                                    {inv.projectName}
                                                    {/* <span>
                                                        <ReactTooltip
                                                            id={'invoice-project-' + index}
                                                            type='dark'
                                                            className='td-tooltip'
                                                            place='top'
                                                            effect='solid'>
                                                            {inv.projectName}
                                                        </ReactTooltip>
                                                    </span> */}
                                                </td>

                                                <td
                                                    className='padding-left-10px padding-right-10px description'
                                                    data-tip
                                                    data-for={'invoice-action-' + index}>
                                                    {inv.actionName}
                                                    {/* <span>
                                                        <ReactTooltip
                                                            id={'invoice-action-' + index}
                                                            type='dark'
                                                            className='td-tooltip'
                                                            place='top'
                                                            effect='solid'>
                                                            {inv.actionName}
                                                        </ReactTooltip>
                                                    </span> */}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                                <tfoot className='divider-sum'>
                                    <tr>
                                        <td className='1'></td>
                                        <td className='font-weight-bold intern-hours text-right padding-right-5px'>
                                            {sumHours(filteredHourInfo, 'hour')}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                            <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_INTERNAL_HOURS_LABEL)}</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default EmpHourList;
